import React, { useEffect, useState } from "react";
import Logo from "../../assets/logo0005.jpeg";
import { Link } from "react-router-dom";
import { Search } from "../Sections/Search";
import { useSearch } from "../../store/context/SearchContext";
import { GoogleAuth } from "../Other/GoogleAuth";

export const Header =  () => {
  const [darkMode, setDarkMode] = useState( JSON.parse(localStorage.getItem("darkMode")) || false);
  const [cmsData, setCmsData] = useState("");
  const [searchSection, setSearchSection] = useState(false);
  const { productsList } = useSearch();


  const handleCms = async () => {
    // const response = await fetch("/.netlify/functions/cmsComunecation", {
      // const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LOCAL}/api/global-setting?[populate][topNavigation]populate=*`)
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/global-setting?[populate][topNavigation]populate=*`)
    
      
    const in_data = await response.json()
    console.log("data.............", in_data)
    setCmsData(in_data.data.topNavigation)
    console.log("data header ======================> line 26 ", in_data.data)
  }



  function itemsCount(){
    // console.log("from itemsCount", productsList.length ? "the length :: " + productsList.length : "sda")
   if(  productsList ){

     return  productsList.length 
   }else
   return 0
     
  }


  // console.log("itemsCount", itemsCount())

  useEffect(() => {
    localStorage.setItem("darkMode", JSON.stringify(darkMode));
    handleCms()
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  return (
    <header className="bg-white dark:bg-gray-900">
      <nav className="px-4 py-3">
        <div className=" flex flex-col items-center border-b border-slate-200 dark:border-b-0 lg:flex-row lg:justify-between lg:mr-20">
          <Link to="/" className="flex items-center ml-20 mb-4">
            <img src={Logo} className="mr-3 h-8" alt="Havia Dynamics" />
            <span className="self-center text-xl font-semibold whitespace-nowrap dark:text-white">
            {cmsData !== "" ? cmsData.logotitle?.label : "Loading..."}
            </span>
          </Link>
          <div className="flex items-center space-x-3 mb-4">
           {cmsData !== "" ? <GoogleAuth itemsCount={itemsCount} cmsData={cmsData.googleLogin?.label} /> : ""}
           
            <button onClick={() => setDarkMode(!darkMode)} className="text-gray-700 dark:text-white" >
              <span className="text-lg bi bi-gear-wide-connected"></span>
            </button>
           
           <button onClick={() => setSearchSection(!searchSection)} className="text-gray-700 dark:text-white" >
              <span className="text-lg bi bi-search"></span>
            </button>
          
            <Link to="/cart" className="text-gray-700 dark:text-white">
              <span className="text-xl bi bi-cart-fill relative">
                {itemsCount() > 0 && (
                  <span className="text-white text-xs absolute -top-1 left-2 bg-rose-500 px-1 rounded-full">
                    {itemsCount()}
                  </span>
                )}
              </span>
            </Link>
            <span className="bi bi-person-circle text-xl text-gray-700 dark:text-white"></span>                
          </div>
        </div>
      </nav>
      {searchSection && <Search />}
    </header>
  );
};


